import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/transportadora' };
/////////////////////////////////////////////////////////////////////////////////

export function createTransportadoraCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateTransportadoraCadastro(payload) {
  const { id } = payload;

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listTransportadoraCadastro(param) {
  return httpService.get({ ...args, args: param });
}

export function findTransportadoraCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllTransportadoraCadastro() {
  return httpService.get({ ...args, path: '/transportadora/all' });
}

export function deleteTransportadoraCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function findCnpj(cnpj) {
  return httpService.get({ ...args, args: `/find/dataByCnpj/${cnpj}` });
}

export function findCep(cep) {
  return httpService.get({ ...args, args: `/find/addressByCep/${cep}` });
}

export function filterTransportadoraCadastro(idPropriedade, where) {
  return httpService.get({
    ...args,
    args: `?propriedade=${idPropriedade}${where}`,
  });
}